export enum ContextMenuId {
  SelectedItems = 'SelectedItems',
  CurrentFolder = 'CurrentFolder',
  Boards = 'Boards',
}
